// extracted by mini-css-extract-plugin
export default {"header":"Index_header__J8VqE","container":"Index_container__LrKvO"};